import script from "./SpaceBarElement.vue?vue&type=script&setup=true&lang=js"
export * from "./SpaceBarElement.vue?vue&type=script&setup=true&lang=js"

import "./SpaceBarElement.vue?vue&type=style&index=0&id=7a78ae4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a78ae4a"]])

export default __exports__